import { getVersionComparisonsReconciliationStatusCountResponseSchema, getVersionComparisonsResponseSchema, getVersionComparisonsUniqueBlobsResponseSchema, versionComparisonSchema, versionComparisonSummarySchema, } from '@consigli/types';
import { createParams, createTransformer, mapToSnakeCase, } from './shared/base-api';
export const versionCompareApiEndpoints = (builder, coreApiBaseUrl) => ({
    getVersionComparisons: builder.query({
        query: ({ projectId, packageId, page, pageSize, search, reconciliationStatus, blobIds, refBlobIds, relatedBlobIds, processorName, hasComment, hasChange, }) => {
            const params = createParams({
                page,
                pageSize,
                search,
                reconciliationStatus,
                blobIds,
                refBlobIds,
                relatedBlobIds,
                processorName,
                hasComment,
                hasChange,
            });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['VersionComparisons'],
        transformResponse: createTransformer(getVersionComparisonsResponseSchema, 'GetVersionComparisons'),
    }),
    getVersionComparison: builder.query({
        query: ({ projectId, packageId, id }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/${id}/`,
            method: 'GET',
        }),
        providesTags: ['VersionComparisons'],
        transformResponse: createTransformer(versionComparisonSchema, 'GetVersionComparison'),
    }),
    // Writes the per-finding review status through the generic detail PATCH; the response is
    // the detail serializer for that one row. Optimistic cache patching happens at the
    // hooks/component layer (the factory-built api slice is not importable here).
    updateVersionComparisonReview: builder.mutation({
        query: ({ projectId, packageId, id, reviewStatus }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/${id}/`,
            method: 'PATCH',
            body: mapToSnakeCase({ reviewStatus }),
        }),
        transformResponse: createTransformer(versionComparisonSchema, 'UpdateVersionComparisonReview'),
    }),
    getVersionComparisonsUniqueBlobs: builder.query({
        query: ({ projectId, packageId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/unique-blobs/`,
            method: 'GET',
        }),
        transformResponse: createTransformer(getVersionComparisonsUniqueBlobsResponseSchema, 'GetVersionComparisonsUniqueBlobs'),
    }),
    getVersionComparisonsSummary: builder.query({
        query: ({ projectId, packageId, search, relatedBlobIds }) => {
            const params = createParams({ search, relatedBlobIds });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/summary/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['VersionComparisons'],
        transformResponse: createTransformer(versionComparisonSummarySchema, 'GetVersionComparisonsSummary'),
    }),
    deleteAllVersionComparisons: builder.mutation({
        query: ({ projectId, packageId, processorName, blobIds, search }) => {
            const params = createParams({ processorName, blobIds, search });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/delete-all/`,
                method: 'DELETE',
                params: mapToSnakeCase(params),
            };
        },
        invalidatesTags: ['VersionComparisons'],
        transformResponse: (raw) => ({
            deletedCount: raw.deleted_count,
        }),
    }),
    getVersionComparisonsReconciliationStatusCount: builder.query({
        query: ({ projectId, packageId, search, blobIds }) => {
            const params = createParams({ search, blobIds });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/packages/${packageId}/version-comparisons/reconciliation-status-count/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['VersionComparisons'],
        transformResponse: createTransformer(getVersionComparisonsReconciliationStatusCountResponseSchema, 'GetVersionComparisonsReconciliationStatusCount'),
    }),
});
